<template>
  <div id="app">
    <div>
      <Navbar/>
      <div>
        <EditoPage :is-course="true"/>
      </div>

    </div>
    <router-view/>
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
import EditoPage from './EditorComponent/EditorPage'

export default {
  name: 'CourseApp',
  components: {
    Navbar,
    EditoPage
  },


}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
